/* router.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
            <path class="foreground-gl" d="M10,.09A9.89,9.89,0,1,0,19.86,10,9.87,9.87,0,0,0,10,.09ZM7.43,5.17,10.19,1a.17.17,0,0,1,.27,0l2.76,4.15a.17.17,0,0,1-.13.27H11.75V7.63h-3V5.44H7.56A.17.17,0,0,1,7.43,5.17Zm.37,6.31H5.62v1.23a.17.17,0,0,1-.27.13L1.22,10.06a.17.17,0,0,1,0-.27L5.35,7a.17.17,0,0,1,.27.13V8.49H7.8ZM13,14.64l-2.76,4.15a.17.17,0,0,1-.27,0L7.19,14.64a.17.17,0,0,1,.13-.27H8.65V12.17h3v2.19h1.22A.17.17,0,0,1,13,14.64Zm2-2.06a.17.17,0,0,1-.27-.13V11.1H12.53v-3h2.18V6.89A.17.17,0,0,1,15,6.75l4.13,2.78a.17.17,0,0,1,0,.27Z" transform="translate(-0.18 -0.09)"/>
        </svg>
    `
};
